import React from "react";
import PropTypes from "prop-types";

import Tooltip from "core/Tooltip";
import { ButtonLink } from "core/Typography";

import RotateLeft from "core/ReusableIcons/RotateLeft";
import RotateRight from "core/ReusableIcons/RotateRight";

import { useIconEditorDispatch } from "js/contexts/IconEditorContext";

const EditorRotate = ({ direction, iconId }) => {
    const dispatch = useIconEditorDispatch();

    const rotateIcon = () => {
        let actionType;

        if (direction === "cw") actionType = "ROTATE_CW";
        if (direction === "ccw") actionType = "ROTATE_CCW";

        dispatch({
            type: actionType,
            iconId
        });
    };

    const getTooltipText = () => {
        if (direction === "cw") return "Rotate Clockwise";
        if (direction === "ccw") return "Rotate Counterclockwise";
    };

    return (
        <Tooltip message={getTooltipText()} size="small">
            <ButtonLink onClick={() => rotateIcon()}>
                {direction === "ccw" && <RotateLeft size="sm" />}
                {direction === "cw" && <RotateRight size="sm" />}
            </ButtonLink>
        </Tooltip>
    );
};

EditorRotate.propTypes = {
    dispatch: PropTypes.func,
    direction: PropTypes.oneOf(["ccw", "cw"]),
    iconId: PropTypes.string
};

export default EditorRotate;
